import { render, staticRenderFns } from "./oldIndex.vue?vue&type=template&id=4929990b&scoped=true&"
import script from "./oldIndex.vue?vue&type=script&lang=js&"
export * from "./oldIndex.vue?vue&type=script&lang=js&"
import style0 from "./oldIndex.vue?vue&type=style&index=0&id=4929990b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4929990b",
  null
  
)

export default component.exports